const emailReg = /^[A-Za-zd0-9]+([-_.][A-Za-zd]+)*@([a-zA-Z0-9]+[-.])+[A-Za-zd]{2,5}$/
const mobileReg = /^1[3-9]\d{9}$/
// const codeReg = /^\d{6}$/
// const textReg = /^[\u4E00-\u9FA3]{1,}$/
// const passWordReg = /^[0-9A-Za-z]{6,24}$/

export { emailReg, mobileReg }
